import { Settings, Cpu, Shield, MapPin } from "lucide-react";
import { ParallaxText, ScrollFadeIn } from "@/components/Parallax";

const PILARES = [
  {
    id: "procesos",
    icon: Settings,
    title: "Procesos",
    description: "Estandarizamos cada etapa: recepción, revisión, segmentación, estrategia, tramitación y cierre."
  },
  {
    id: "tecnologia",
    icon: Cpu,
    title: "Innovación y Tecnología",
    description: "Aplicamos herramientas de control y seguimiento para mejorar la trazabilidad, reportabilidad y visibilidad de las causas."
  },
  {
    id: "confiabilidad",
    icon: Shield,
    title: "Confiabilidad",
    description: "Buscamos una gestión consistente, eficiente y orientada a resultados durante toda la cadena de recuperación."
  },
  {
    id: "cobertura",
    icon: MapPin,
    title: "Cobertura nacional",
    description: "Un solo canal para todo Chile."
  }
];

export default function DiferencialSection() {
  return (
    <section id="diferencial" data-testid="diferencial-section" className="py-20 md:py-28 lg:py-32 bg-calle-primary text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <ParallaxText speed={-0.15}>
          <div className="text-center mb-16">
            <ScrollFadeIn direction="up" delay={0}>
              <p className="text-white/50 text-xs uppercase tracking-[0.3em] mb-4 font-semibold font-body">
                No es solo tramitación: gestionamos carteras
              </p>
            </ScrollFadeIn>
            <ScrollFadeIn direction="up" delay={0.1}>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-[-0.01em] max-w-4xl mx-auto mb-6">
                Nuestro diferencial
              </h2>
            </ScrollFadeIn>
            <ScrollFadeIn direction="up" delay={0.15}>
              <div className="w-20 h-0.5 bg-white/30 mx-auto mb-8"></div>
            </ScrollFadeIn>
            <ScrollFadeIn direction="up" delay={0.2}>
              <p className="text-white/70 text-base max-w-3xl mx-auto leading-relaxed font-body">
                Entendemos la cobranza judicial como una gestión integral y estratégica de las carteras de créditos confiadas a nosotros. Por eso, combinamos experiencia jurídica, eficiencia del uso de recursos, procesos y herramientas tecnológicas propias y de los clientes para el seguimiento de cartera, proporcionando una gestión trazable, confiable y eficiente de acuerdo a los requerimientos del cliente.
              </p>
            </ScrollFadeIn>
          </div>
        </ParallaxText>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {PILARES.map((pilar, index) => (
            <ScrollFadeIn 
              key={pilar.id} 
              direction="up" 
              delay={0.1 + index * 0.1}
            >
              <ParallaxText speed={-0.03 * (index + 1)}>
                <div 
                  data-testid={`pilar-${pilar.id}`}
                  className="bg-white/5 backdrop-blur-sm p-6 lg:p-8 rounded-sm border border-white/10 hover:border-white/40 transition-all duration-500 hover:bg-white/15 group h-full min-h-[320px] flex flex-col hover:-translate-y-3"
                >
                  <div className="w-12 h-12 rounded-sm bg-white/10 flex items-center justify-center mb-5 group-hover:bg-white/30 group-hover:scale-110 transition-all duration-500">
                    <pilar.icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="font-heading text-lg lg:text-xl text-white mb-3">
                    {pilar.title}
                  </h3>
                  <p className="text-white/60 text-sm leading-relaxed font-body group-hover:text-white/80 transition-colors duration-500">
                    {pilar.description}
                  </p>
                </div>
              </ParallaxText>
            </ScrollFadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
